import template from './vd-load-more.html'

const LoadMoreComponent = {
  bindings: {
    labelText: '@?',
    isLoading: '<?',
    action: '&',
  },
  template,
}

export default LoadMoreComponent
